import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Briefcase, MapPin, Clock, ArrowRight, Send } from "lucide-react";
import PageBanner from "../components/PageBanner";

const openings = [
  {
    id: 1,
    title: "Application Engineer - FDM",
    type: "Full-time",
    location: "Bangalore, India",
    description: "Operate and maintain FDM 3D printers, optimize print parameters, and assist clients with design-for-manufacturing recommendations."
  },
  {
    id: 2,
    title: "Product Designer / CAD Engineer",
    type: "Full-time",
    location: "Bangalore, India",
    description: "Create production-ready 3D models using SolidWorks/Fusion 360. Work closely with clients on design iterations and DFAM optimization."
  },
  {
    id: 3,
    title: "Business Development Executive",
    type: "Full-time",
    location: "Bangalore, India",
    description: "Drive new business acquisition, manage client relationships, and expand 3D Printzkart's market presence across India."
  },
  {
    id: 4,
    title: "Intern - 3D Printing & Design",
    type: "Internship (3-6 months)",
    location: "Bangalore, India",
    description: "Hands-on learning with FDM, SLA, and SLS technologies. Assist with design projects, print operations, and quality checks."
  }
];

const CareersPage = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <>
      <PageBanner
        title="Careers"
        subtitle="Join the League of Makers"
        image="https://images.unsplash.com/photo-1611117775350-ac3950990985?w=1920&h=600&fit=crop"
        breadcrumbs={[{ label: "Careers" }]}
      />

      <section className="inner-section" ref={ref}>
        <div className="inner-container">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6 }}>
            <span className="section-subtitle">Work With Us</span>
            <h2 className="section-title">Current Openings</h2>
            <div className="section-line" />
            <p className="section-intro-text">
              At 3D Printzkart, we're building the future of additive manufacturing in India.
              Join our Bangalore team and work with cutting-edge 3D printing technologies.
            </p>
          </motion.div>

          <div className="careers-grid">
            {openings.map((job, i) => (
              <motion.div key={job.id} className="career-card"
                initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4, delay: i * 0.1 }}>
                <h3>{job.title}</h3>
                <div className="career-meta">
                  <span><Briefcase size={14} /> {job.type}</span>
                  <span><MapPin size={14} /> {job.location}</span>
                </div>
                <p>{job.description}</p>
                <a href="mailto:orders@3dprintzkart.com?subject=Application for: {{job.title}}" className="service-link">
                  Apply Now <ArrowRight size={16} />
                </a>
              </motion.div>
            ))}
          </div>

          <div className="careers-general">
            <h3>Don't see your role?</h3>
            <p>Send your resume to <a href="mailto:orders@3dprintzkart.com">orders@3dprintzkart.com</a> and we'll reach out when something fits.</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-inner">
          <h2 className="cta-title">Build Your Career in Additive Manufacturing</h2>
          <p className="cta-desc">Be part of Bangalore's leading 3D printing team. We offer hands-on experience with the latest technologies and a collaborative work environment.</p>
          <Link to="/contact" className="btn-primary">Contact Us <ArrowRight size={18} /></Link>
        </div>
      </section>
    </>
  );
};

export default CareersPage;
